import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/report",

        async list({ page = 0, channelType }) {
            const url = this.userUrl({ path: `/${page}` });

            return Vue.http.get(url, {
                params: {
                    channelType
                }
            });
        },
    },
    base
);
